import React from 'react';
import { useLocation } from 'react-router-dom';

export const Footer: React.FC = () => {
  const { pathname } = useLocation();
  const isHome = pathname === '/';

  return (
    <footer className="footer">
      <div className="container">
        <div
          className="footer-bottom"
          style={isHome ? { borderTop: '1px solid rgba(255,255,255,0.15)', paddingTop: 20 } : undefined}
        >
          <span>&copy; 2026 Retail Derivatives Forum. All rights reserved.</span>
          <a href="mailto:admin@rdf.global">admin@rdf.global</a>
        </div>
      </div>
    </footer>
  );
};
